import {Injectable} from "@angular/core";

export enum LanguageVariations {
  HY = 'HY',
  RU = 'RU',
  EN = 'EN',
}

@Injectable({
  providedIn: 'root'
})
export class LanguageVariationsUtil {
  getNotSelectedLanguage(variation: LanguageVariations) {
    switch (variation) {
      case LanguageVariations.EN:
        return Array.of(LanguageVariations.RU, LanguageVariations.HY);
      case LanguageVariations.HY:
        return Array.of(LanguageVariations.EN, LanguageVariations.RU);
      case LanguageVariations.RU:
        return Array.of(LanguageVariations.HY, LanguageVariations.EN);
    }
  }
}
